import { render, staticRenderFns } from "./OurAim.vue?vue&type=template&id=d763d33c&"
import script from "./OurAim.vue?vue&type=script&lang=js&"
export * from "./OurAim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports